<div class="cbolui-cds cbolui-cds-blue-vis-id {{this.pageDataObj?.pageInfo?.themeName}}">
    @if(compDataExceptSticky?.[0]?.component){
    @if(showStickyHeader) {
    <ng-container *ngComponentOutlet="stickyCompData?.component; inputs:stickyCompData.data" #instance="ngComponentOutlet"></ng-container>
    }
    <section id="page-container" class="citi-section">
        <ng-container
            *ngComponentOutlet="compDataExceptSticky?.[0]?.component; inputs:compDataExceptSticky[0].data"></ng-container>
        <div id="pdp-content-container" class="container d-flex flex-column w-100">
            @for(item of compDataExceptSticky?.slice(1);track $index){
            <ng-container *ngComponentOutlet="item.component; inputs:item.data"></ng-container>
            }
        </div>
    </section>
    @if(showStickyFooter) {
    <ng-container *ngComponentOutlet="stickyCompData?.component; inputs:stickyCompData.data"></ng-container>
    }
    }
</div>
